<astral-button variant="primary" size="small" type="button" icon="excel" labelKey="COMMON.EXCEL" (click)="openSideBar()"></astral-button>

<app-excel-management-sidebar
  [open]="showExcelColumnSidebar"
  [items]="excelColumnItems"
  [columnDefinition]="columnDefinition"
  [title]="'CHANGE_EXCEL_COLUMNS_BTN'"
  [searchCaption]="'SEARCH_COLUMNS'"
  [validate]="true"
  [showRadioCheckbox]="showCheckbox"
  (onSave)="onExcelColumnsSave($event)"
  (onCancel)="sideBarCancel()"
>
</app-excel-management-sidebar>
